import React, { PureComponent } from 'react';
// Components
import styles from './chart.scss';
import { LABEL_WIDTH } from './utils';
interface ChartLineProps {
  offset: number;
  width: number;
  height: number;
}
export default class ChartLine extends PureComponent<ChartLineProps> {
  render() {
    const { offset, width, height } = this.props;
    const x = offset * (width - LABEL_WIDTH) + LABEL_WIDTH;
    return <line x1={x} x2={x} y1={0} y2={height} className={styles.line} />;
  }
}
